import { Button } from "components/lib";
import Style from "./table.module.scss";

export default function TableActions(props) {
  const row = props.row;

  return (
    <td key={props.index} className={Style.actions}>
      {row.actions?.custom?.map((action, i) => {
        if (action.condition) {
          return row[action.condition.col] === action.condition.value ? (
            <Button
              key={i}
              icon={action.icon}
              color={action.color}
              action={() => action.action(row)}
              className={Style.actionButton}
              tooltip={action.tooltip}
            />
          ) : (
            false
          );
        }

        return (
          <Button
            key={i}
            icon={action.icon}
            color={action.color}
            action={() => action.action(row)}
            className={Style.actionButton}
            tooltip={action.tooltip}
          />
        );
      })}

      {row.actions.edit && (
        <Button
          icon="edit"
          color={row.actions.edit.color}
          action={() =>
            row.actions.edit(row, (res) => props.callback.edit(res, row))
          }
          tooltip={row.actions.edit.tooltip}
          className={Style.actionButton}
        />
      )}

      {row.actions.download && (
        <Button
          icon="download"
          color={row.actions.download.color}
          url={row.actions.download}
          className={Style.actionButton}
          tooltip={row.actions.download.tooltip}
        />
      )}

      {row.actions.view && (
        <Button
          icon="eye"
          color={row.actions.view.color}
          url={`${row.actions.view.url}/${row[row.actions.view.col]}`}
          className={Style.actionButton}
          tooltip={row.actions.view.tooltip}
        />
      )}

      {row.actions.email && (
        <Button
          icon="mail"
          color={row.actions.email.color}
          action={() => (window.location = `mailto:${row.email}`)}
          className={Style.actionButton}
          tooltip={row.actions.email.tooltip}
        />
      )}

      {row.actions.invite && (
        <Button
          icon="mail"
          color={row.actions.invite.color}
          action={(e) => row.actions.invite(row)}
          className={Style.actionButton}
          tooltip={row.actions.invite.tooltip}
        />
      )}

      {row.actions.delete && (
        <Button
          icon="trash"
          color={row.actions.delete.color}
          action={() =>
            row.actions.delete(row, (res) => props.callback.delete(res, row))
          }
          className={Style.actionButton}
          tooltip={row.actions.delete.tooltip}
        />
      )}
    </td>
  );
}
